import React from 'react';
import { IHolidayPeriod } from 'gen/ApiClient';
import { ICacheContext } from 'framework/context/ICacheContext';

export const HolidayPeriodsCacheContext = React.createContext<ICacheContext<IHolidayPeriod[]>>(undefined as any);